<div class="form-field">
  @if (name) {
    <label class="label" [class.bold]="bold" [attr.for]="inputId">
      <span>{{name}}</span>
    </label>
  }
  <div class="buttons">
    @if (isPassword) {
      <button type="button" class="btn btn-link" (click)="toggleMasking()">
        {{masked ? 'Show' : 'Hide'}} {{showHideLabel}}
      </button>
    }
  </div>
  <input
    [id]="inputId"
    [type]="formControlType"
    [placeholder]="placeholder"
    [formControl]="control"
    class="form-control main-input"
    [class.valid-icon]="validation"
    [class.invalid-icon]="validation"
    [readonly]="readonly"
    [autocomplete]="autocomplete"
    >
  <div class="actions">
    <ng-content></ng-content>
  </div>
  @if (showError) {
    <div class="input-error">
      <span>{{errorPresentation}}</span>
    </div>
  }
</div>
